export default "__VITE_ASSET__zcwBG9ul__"